// packages/data/src/default-registry.ts
import { createRegistry } from "./registry.mjs";
var defaultRegistry = createRegistry();
var default_registry_default = defaultRegistry;
export {
  default_registry_default as default
};
//# sourceMappingURL=default-registry.mjs.map
